import React from 'react';
import HomePage from '../Pages/HomePage/HomePage';

const publicRoutes = [{ path: '/', component: <HomePage /> }];

export { publicRoutes };
